export default __webpack_public_path__ + "static/media/inReakt_award.672864cd.png";